export const ACCESS_TOKEN = "Hlcloud-Access-Token-Portal";
export const REFRESH_TOKEN = "Hlcloud-Refresh-Token-Portal";
export const SESSION_COMPANY_ID = "SESSION_COMPANY_ID";
